import Vue from 'vue';
import ErrorVue from '@/components/Global/Error.vue';
import LoadingIndicatorVue from '@/components/Global/LoadingIndicator.vue';
import HelpIcon from '@/components/Global/HelpIcon.vue';

// Register components globally
Vue.component('kws-error', ErrorVue);
Vue.component('kws-loading-indicator', LoadingIndicatorVue);
Vue.component('kws-help-icon', HelpIcon);
